/**
 * Converts HTML content to Markdown.
 * Used to convert contentEditable HTML to markdown for message sending.
 */

const convertNode = (node) => {
  let result = '';

  for (const child of node.childNodes) {
    if (child.nodeType === Node.TEXT_NODE) {
      result += child.textContent;
    } else if (child.nodeType === Node.ELEMENT_NODE) {
      const tag = child.tagName.toLowerCase();
      const inner = convertNode(child);

      switch (tag) {
        case 'strong':
        case 'b':
          result += `**${inner}**`;
          break;
        case 'em':
        case 'i':
          result += `*${inner}*`;
          break;
        case 'u':
          result += inner;
          break;
        case 'h1':
          result += `\n# ${inner}\n`;
          break;
        case 'h2':
          result += `\n## ${inner}\n`;
          break;
        case 'h3':
          result += `\n### ${inner}\n`;
          break;
        case 'h4':
          result += `\n#### ${inner}\n`;
          break;
        case 'h5':
          result += `\n##### ${inner}\n`;
          break;
        case 'h6':
          result += `\n###### ${inner}\n`;
          break;
        case 'p':
          result += `\n${inner}\n`;
          break;
        case 'br':
          result += '\n';
          break;
        case 'div':
          result += `\n${inner}`;
          break;
        case 'ul':
          result += '\n' + convertList(child, false) + '\n';
          break;
        case 'ol':
          result += '\n' + convertList(child, true) + '\n';
          break;
        case 'li':
          result += inner;
          break;
        case 'a': {
          const href = child.getAttribute('href');
          if (href) {
            result += `[${inner}](${href})`;
          } else {
            result += inner;
          }
          break;
        }
        case 'code':
          result += `\`${inner}\``;
          break;
        case 'pre':
          result += `\n\`\`\`\n${inner}\n\`\`\`\n`;
          break;
        case 'blockquote':
          result += '\n' + inner.split('\n').map(line => `> ${line}`).join('\n') + '\n';
          break;
        default:
          result += inner;
      }
    }
  }

  return result;
};

const convertList = (listNode, ordered) => {
  let result = '';
  let index = 1;

  for (const child of listNode.childNodes) {
    if (child.nodeType === Node.ELEMENT_NODE && child.tagName.toLowerCase() === 'li') {
      const inner = convertNode(child).trim();
      if (ordered) {
        result += `${index}. ${inner}\n`;
        index++;
      } else {
        result += `- ${inner}\n`;
      }
    }
  }

  return result.trimEnd();
};

export const htmlToMarkdown = (html) => {
  if (!html || typeof html !== 'string') return '';

  const temp = document.createElement('div');
  temp.innerHTML = html;

  return convertNode(temp).trim().replace(/\n{3,}/g, '\n\n');
};

export default htmlToMarkdown;
